import React, {Fragment} from "react";
import {Button} from "antd";
import {useNavigate} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {
    globalEWalletSettingState,
    globalUserDetailState,
    globalUserTradingAccount,
} from "../../../../_common/global_state";
import {useTranslation} from "react-i18next";
import {CheckOutlined} from "@ant-design/icons";
import {useIsMobile} from "../../../../_common/function";

export const GetStarted_3 = ({setCollapsed}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const isTablet = useIsMobile(991)

    const userDetails = useRecoilValue(globalUserDetailState);
    const tradingAccState = useRecoilValue(globalUserTradingAccount);
    const eWalletSetting = useRecoilValue(globalEWalletSettingState);

    const hasVerified = userDetails?.isKycApproved;
    const hasTradingAccount = tradingAccState?.filter(d => d?.mode === "live")?.length;
    const depositWithKyc = eWalletSetting?.depositWithKyc;

    return (
        <>
            <div className={`sider-title ${!isTablet ? "border-0" : ""}`}>
                {t("common.getstarted")}
            </div>
            <div className={"quick-action-container"}>
                <div className={`custom-card quick-action-item ${!hasVerified ? "active-action" : ""}`}>
                    <div className={"numbering"}>1</div>
                    <div className={"labeling"}>{t("common.verify")}</div>
                    {!hasVerified ? (
                        <Button
                            type={"primary"}
                            onClick={() => {
                                navigate("/account-verification");
                                setCollapsed(false)
                            }}
                        >
                            {t("common.verify")}
                        </Button>
                    ) : (
                        <div className={"pending-active"}>
                            <CheckOutlined/>
                        </div>
                    )}
                </div>
                <div className={`custom-card quick-action-item ${hasVerified ? "active-action" : ""}`}>
                    <div className={"numbering"}>2</div>
                    <div className={"labeling"}>{t("common.deposit")}</div>
                    {(!hasVerified && depositWithKyc) ? (
                        <div className={"pending-active"}>
                            {t("common.pending")}
                        </div>
                    ) : (
                        <Button
                            type={"primary"}
                            onClick={() => {
                                navigate("/wallet-deposit");
                                setCollapsed(false)
                            }}
                        >
                            {t("common.deposit")}
                        </Button>
                    )}
                </div>
                <div
                    className={`custom-card quick-action-item ${hasVerified && !hasTradingAccount ? "active-action" : ""}`}
                >
                    <div className={"numbering"}>3</div>
                    <div className={"labeling"}>
                        {t("user.tradingAccount")}
                    </div>
                    {hasTradingAccount ? (
                        <div className={"pending-active"}>
                            <CheckOutlined/>
                        </div>
                    ) : !hasVerified ? (
                        <div className={"pending-active"}>
                            {t("common.pending")}
                        </div>
                    ) : (
                        <Button
                            type={"primary"}
                            onClick={() => {
                                navigate("/self-trade");
                                setCollapsed(false)
                            }}
                        >
                            {t("common.add")}
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
};
